import classNames from 'classnames';
import React from 'react';

export interface ButtonProps {
  id?: string;
  onClick?: () => void;
  pill?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  size?: 'large' | 'medium' | 'small';
  btnStyle?: 'flat' | 'outline' | 'solid';
  color?:
    | 'none'
    | 'black'
    | 'error'
    | 'primary'
    | 'reversed'
    | 'secondary'
    | 'success'
    | 'warning';
  type?: string;
  iconOnly?: boolean;
  shape?: 'round' | 'square';
  children: React.ReactNode;
  className?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  noPadding?: boolean;
  noHover?: boolean;
  tabIndex?: number;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const {
      id,
      className,
      disabled,
      isLoading,
      onClick,
      size = 'large',
      btnStyle = 'solid',
      color = 'primary',
      type,
      iconOnly,
      shape = 'square',
      children,
      pill,
      startIcon,
      endIcon,
      noPadding,
      noHover,
      ...otherProps
    } = props;

    const btnClass = classNames(
      className,
      'ui-button',
      `ui-button--${btnStyle}--${color}${noHover ? '--no-hover' : ''}`,
      {
        [`ui-button--${size}`]: !noPadding,
        'ui-button--pill': pill,
        'ui-button--loading': btnStyle === 'solid' ? isLoading : '',
        'ui-button--icon-start': startIcon,
        'ui-button--icon-end': endIcon,
        'ui-button--no-padding': noPadding,
        'ui-button-icon': iconOnly,
        [`ui-button-icon--${shape}`]: iconOnly,
        [`ui-button-icon--${size}`]: iconOnly,
      }
    );

    return (
      <button
        id={id}
        className={btnClass}
        disabled={disabled}
        onClick={!isLoading ? onClick : () => {}}
        type={type ? 'submit' : 'button'}
        ref={ref}
        {...otherProps}
      >
        {startIcon}
        {children}
        {endIcon}
      </button>
    );
  }
);

export default Button;
